import React from "react";

import RetailerAssistantPanel from "./RetailerAssistantPanel";
import RetailerPdp from "./RetailerPdp";
import { ASSISTANT_PRODUCT, useRetailerAssistant } from "./useRetailerAssistant";

/**
 * Retailer PDP with the Compass "Your Assistant" panel docked open.
 *
 * Mirrors the production interaction: the panel is `position: fixed` on the
 * left, full-height; opening it slides the rail in (translateX) while the page
 * content is pushed right via an animated `padding-left` (300ms ease-out).
 * Tapping a prompt pill seeds the question and shows a "Researching…" loading
 * state before the scripted answer renders; the composer and follow-up pills
 * send further (scripted) questions. Closing slides the rail back out.
 */

const PANEL_WIDTH = 359;

const RetailerPdpWithAssistant: React.FC = () => {
  const { isOpen, messages, pending, autoFocusKey, open, close, send } =
    useRetailerAssistant();

  return (
    <div className="relative flex min-h-screen w-full">
      <div
        className="fixed inset-y-0 left-0 z-40 transition-transform duration-300 ease-out"
        style={{
          width: PANEL_WIDTH,
          transform: isOpen ? "translateX(0)" : `translateX(-${PANEL_WIDTH}px)`,
        }}
        aria-hidden={!isOpen}
      >
        <RetailerAssistantPanel
          productName={ASSISTANT_PRODUCT.name}
          productBrand={ASSISTANT_PRODUCT.brand}
          productImage={ASSISTANT_PRODUCT.image}
          messages={messages}
          pending={pending}
          autoFocusKey={autoFocusKey}
          onClose={close}
          onSend={send}
        />
      </div>
      <div
        className="min-w-0 flex-1 transition-[padding-left] duration-300 ease-out"
        style={{ paddingLeft: isOpen ? PANEL_WIDTH : 0 }}
      >
        <RetailerPdp onAskAssistant={open} />
      </div>
    </div>
  );
};

export default RetailerPdpWithAssistant;
